import List from "./list/list.module";
import Report from "./report/report.store";

export default {
  modules: { List, Report },
};
